// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterToggle-cls1_-_M","cls2":"FilterToggle-cls2_q5I FilterToggle-cls1_-_M","mobileLayout":"FilterToggle-mobileLayout_Fkj"};